const wearableAssets = require.context(
  './imgs/wearables',
  true,
  /\.(png|jpe?g|gif)$/i
);

const ICON_OVERRIDES = {
  'berps/mask_berp': 'berps/berp_mask-icon',
  'misc/btn': 'misc/btn_icon',
  'misc/hth-hoodie': 'misc/hth-icon',
  'misc/mask': 'misc/mask_icon',
  'misc/sign': 'misc/sign_icon',
  'misc/derpers-hot-derpefier': 'misc/snack_derpers-chips',
  'star-wars/probe-frame': 'star-wars/probe',
  'star-wars/r2d2': 'star-wars/r2d2icon',
  'star-wars/saber-green-plain': 'star-wars/saber-icon',
  'star-wars/saber-red': 'star-wars/saber-icon-dark',
  'star-wars/vaydurhelmet': 'star-wars/helmet-icon',
};

const ICON_ONLY_ASSETS = new Set([
  'misc/btn_icon',
  'misc/mask_icon',
  'misc/snack_derpers-chips',
  'misc/sign_icon',
  'star-wars/probe',
  'star-wars/r2d2icon',
  'star-wars/saber-icon-dark',
]);

const REPRESENTATIVE_ITEMS = {
  '420': 'bong',
  berps: 'mask_berp',
  christmas: 'santa',
  easter: 'hoodie_easter',
  halloween: 'ghost',
  'july-fourth': 'flag',
  'lunar-new-year': 'horsehead',
  misc: 'derpers-hot-derpefier',
  nye: 'sparkler',
  sonic: 'lanyard',
  'st-patricks-day': 'lep-hat',
  'star-wars': 'saber-green-plain',
  thanksgiving: 'pilgrim',
};

const titleCase = (value) => value
  .replace(/[-_]+/g, ' ')
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const getLayer = (itemName) => {
  if (/(hoodie|sweater|robe|pants)/i.test(itemName)) return 10;
  if (/(head|hat|beanie|helmet|mask|santa|pilgrim|pirate|native)/i.test(itemName)) return 20;
  return 30;
};

const assets = wearableAssets.keys().reduce((result, assetPath) => {
  const normalizedPath = assetPath.replace(/^\.\//, '');
  const pathWithoutExtension = normalizedPath.replace(/\.[^.]+$/, '');
  result[pathWithoutExtension] = wearableAssets(assetPath);
  return result;
}, {});

const categoryNames = [...new Set(
  Object.keys(assets).map((assetPath) => assetPath.split('/')[0])
)].sort();

export const wearableCategories = categoryNames.map((categoryName) => {
  const prefix = `${categoryName}/`;
  const overlayNames = Object.keys(assets)
    .filter((assetPath) => (
      assetPath.startsWith(prefix)
      && !assetPath.endsWith('-icon')
      && !ICON_ONLY_ASSETS.has(assetPath)
    ))
    .map((assetPath) => assetPath.slice(prefix.length))
    .sort();

  const items = overlayNames.map((itemName) => {
    const id = `${categoryName}/${itemName}`;
    const iconPath = ICON_OVERRIDES[id] || `${id}-icon`;

    return {
      id,
      categoryId: categoryName,
      name: titleCase(itemName),
      image: assets[id],
      icon: assets[iconPath] || assets[id],
      layer: getLayer(itemName),
    };
  });

  const representativeName = REPRESENTATIVE_ITEMS[categoryName];
  const representative = items.find((item) => item.id === `${categoryName}/${representativeName}`) || items[0];

  return {
    id: categoryName,
    name: titleCase(categoryName),
    icon: representative?.icon,
    items,
  };
});
